// @ts-strict-ignore
import type { WorkflowState } from 'flow/store/redux/state';
import type { Change } from './changes';


export enum Operation {
  Add = 'add',
  Modify = 'modify',
  Remove = 'remove',
}


export type ChangesByActionPublicId = Record<string, Change[]>;

export type ChangesByOperation = Record<Operation, Change[]>;

export interface ProcessingBuffer<E = any, R = any> {
  append(i: E | E[]): void;
  package(): R;
}


export type Comparable = {
  actions: WorkflowState['workflowData']['actions'];
  thresholds: WorkflowState['workflowData']['thresholds'];
  dataRoutes: WorkflowState['workflowData']['dataRoutes'];
  sdkConfig: WorkflowState['workflowData']['sdkConfig'];
  publishedAttributes: WorkflowState['workflowProps']['publishedAttributes'];
  failureHandlingMode: WorkflowState['workflowData']['failureHandlingMode'];
};


export type ChangelogInputBundle = {
  props: WorkflowState['workflowProps'];
  version: WorkflowState['workflowData'];
};
